import React from 'react';
import Coverage from '../../components/PublicSite/Coverage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Coverage — Car Recovery Across All 7 Emirates | Bas Recovery',
    description: 'Median response times by emirate and by Dubai area, from the last 30 days. Highways, desert and inter-emirate recovery. Call 050 505 2213.',
    component: (
      <HeadLessLayout>
        <Coverage />
      </HeadLessLayout>
    ),
  };
}

export default action;
